import { render, staticRenderFns } from "./IconTelegram.vue?vue&type=template&id=687f841f&"
import script from "./IconTelegram.vue?vue&type=script&lang=js&"
export * from "./IconTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('687f841f')) {
      api.createRecord('687f841f', component.options)
    } else {
      api.reload('687f841f', component.options)
    }
    module.hot.accept("./IconTelegram.vue?vue&type=template&id=687f841f&", function () {
      api.rerender('687f841f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconTelegram.vue"
export default component.exports